import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
var ObservablePoint = /*#__PURE__*/function () {
  function ObservablePoint(cb, scope) {
    var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    _classCallCheck(this, ObservablePoint);
    this._x = x;
    this._y = y;
    this.cb = cb;
    this.scope = scope;
  }
  _createClass(ObservablePoint, [{
    key: "clone",
    value: function clone() {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.cb;
      var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.scope;
      return new ObservablePoint(cb, scope, this._x, this._y);
    }
  }, {
    key: "set",
    value: function set() {
      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
      if (this._x !== x || this._y !== y) {
        this._x = x;
        this._y = y;
        this.cb.call(this.scope);
      }
      return this;
    }
  }, {
    key: "copyFrom",
    value: function copyFrom(p) {
      if (this._x !== p.x || this._y !== p.y) {
        this._x = p.x;
        this._y = p.y;
        this.cb.call(this.scope);
      }
      return this;
    }
  }, {
    key: "copyTo",
    value: function copyTo(p) {
      p.set(this._x, this._y);
      return p;
    }
  }, {
    key: "equals",
    value: function equals(p) {
      return p.x === this._x && p.y === this._y;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "[@pixi/math:ObservablePoint x=".concat(0, " y=", 0, " scope=", this.scope, "]");
    }
  }, {
    key: "x",
    get: function get() {
      return this._x;
    },
    set: function set(value) {
      if (this._x !== value) {
        this._x = value;
        this.cb.call(this.scope);
      }
    }
  }, {
    key: "y",
    get: function get() {
      return this._y;
    },
    set: function set(value) {
      if (this._y !== value) {
        this._y = value;
        this.cb.call(this.scope);
      }
    }
  }]);
  return ObservablePoint;
}();
export { ObservablePoint };